var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageQuestionHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 15.3584H10.8332L7.12483 17.825C6.57483 18.1917 5.83317 17.8 5.83317 17.1334V15.3584C3.33317 15.3584 1.6665 13.6917 1.6665 11.1917V6.19166C1.6665 3.69166 3.33317 2.02499 5.83317 2.02499H14.1665C16.6665 2.02499 18.3332 3.69166 18.3332 6.19166V11.1917C18.3332 13.6917 16.6665 15.3584 14.1665 15.3584Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.46665V9.29169C10 8.72502 10.35 8.42501 10.7 8.18334C11.0417 7.95001 11.3833 7.65002 11.3833 7.10002C11.3833 6.33335 10.7667 5.71665 10 5.71665C9.23334 5.71665 8.6167 6.33335 8.6167 7.10002",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99641 11.4583H10.0039",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestionHeaderIcon);
export default __webpack_public_path__ + "static/media/message-question-header-icon.b9d02ab094cb3eaca4fffc41a2665f94.svg";
export { ForwardRef as ReactComponent };